import isRowNotEmpty from "utils/EventForms/FormGrid/isRowNotEmpty";

export default (values, fields) =>
  values.filter(row => isRowNotEmpty(row, fields));
